var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoMemberReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    viewBox: "0 0 48 48",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M23.903 13c-3.23 0-5.871 2.618-5.871 5.838s2.64 5.839 5.871 5.839c3.23 0 5.872-2.618 5.872-5.838S27.134 13 23.903 13m-3.871 5.838c0-2.104 1.733-3.838 3.871-3.838s3.872 1.734 3.872 3.838-1.734 3.839-3.872 3.839-3.871-1.734-3.871-3.838Zm3.932 6.965h-.05a22.2 22.2 0 0 0-7.484 1.492l-.01.004c-1.284.51-2.349 1.111-3.11 1.798-.758.682-1.31 1.541-1.31 2.545v2.297c0 1.145.93 2.05 2.05 2.05l19.707.01c1.145 0 2.05-.929 2.05-2.049v-2.297c0-1.008-.552-1.868-1.311-2.55-.762-.685-1.828-1.283-3.109-1.793h-.002a21.9 21.9 0 0 0-7.421-1.507m-9.316 4.78c.522-.47 1.35-.963 2.506-1.424a20.2 20.2 0 0 1 6.78-1.356c2.287.066 4.57.519 6.715 1.366 1.16.462 1.988.952 2.51 1.421.525.472.647.833.647 1.063v2.297a.05.05 0 0 1-.014.036l-.015.01-.02.004-19.708-.011a.05.05 0 0 1-.035-.015l-.01-.015-.004-.02v-2.297c0-.223.121-.585.648-1.06Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMemberReport);
export default __webpack_public_path__ + "static/media/IcoMemberReport.08a8092597ba2aa2d24929ba973c65cc.svg";
export { ForwardRef as ReactComponent };